import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * EvolutionPanel — redirect to IntegrationCenter with Evolution modal open.
 * Maintains route /tenant/integrations/evolution for bookmarks/compatibility.
 */
export default function EvolutionPanel() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/tenant/integrations?modal=evolution', { replace: true });
  }, [navigate]);
  return null;
}
